import React from "react";

const benefitItems = [
  {
    icon: "fa-cogs",
    title: "AI-Driven Content Optimization",
    description: "Automatically generate LinkedIn posts tailored to industry trends and best practices.",
    textWhite: true,
    color: "#fff",
     backgroundcolor:"#2e3192"
  },
  {
    icon: "fa-clock-o",
    title: "Automated Scheduling",
    description: "Schedule posts at optimal engagement times, ensuring maximum visibility.",
    textWhite: false,
    color: "#2e3192",
  },
  {
    icon: "fa-folder",
    title: "Client Profile Management",
    description: "Effortlessly manage multiple clients from a single, easy-to-use dashboard.",
    textWhite: false,
    color: "#2e3192",
  },
  {
    icon: "fa-list",
    title: "Performance Analytics",
    description: "Track and analyze engagement, audience growth, and content effectiveness.",
    textWhite: true,
    color: "#fff",
     backgroundcolor:"#2e3192"
  },
];

const KeyBenefits = () => {
  return (
    <div className="features-area overflow-hidden bg-gray default-padding">
      {/* Fixed Shape */}
      <div className="fixed-shape shape left bottom">
        <img
          decoding="async"
          src="https://wpriverthemes.com/tandaelem/wp-content/uploads/2022/01/3-1.png"
          alt="Shape"
        />
      </div>

      <div className="container">
        <div className="row align-center">
          {/* Left Column */}
          <div className="col-lg-5 why-us mt-5">
            <h5>Key Benefits</h5>
            <h2>Empowering your personal brand, one post at a time.</h2>
            <p>
              KnackVibes revolutionizes how professionals and agencies manage LinkedIn profiles,
              combining automation with intelligence to create an engaging online presence.
            </p>
          </div>

          {/* Right Column - Features Grid */}
          <div className="col-lg-7 features-box text-center">
            <div className="row">
              {benefitItems.map((item, index) => (
                <div className="col-lg-6 col-md-6 col-sm-12 item-grid" key={index}>
                 <div className={`item ${index % 2 === 0 ? "mt-5" : "mb-3"}`} style={{color:`${item.color}`,backgroundColor:`${item.backgroundcolor}`}}>
                    <i className={`fa ${item.icon}`} style={{ color: `${item.color}`, fontSize: '50px' }}></i>
                    <h5 className={item.textWhite ? "text-white" : "benifit-heading"}>{item.title}</h5>
                    <p className={item.textWhite ? "text-white" : ""}>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .site-heading h2 {
          display: inline-block;
          font-weight: 600;
          padding-bottom: 20px;
          margin-bottom: 0;
          position: relative;
          letter-spacing: 1px;
          line-height: 1.4;
          margin-top: 40px;
        }
        .site-heading h2::before {
          background: #086ad8 none repeat scroll 0 0;
          bottom: 0;
          content: "";
          height: 2px;
          left: 50%;
          margin-left: -25px;
          position: absolute;
          width: 40px;
        }
        .work-process-area .work-pro-items .item i {
          display: inline-block;
          color: #086ad8;
          font-size: 60px;
          margin-bottom: 30px;
        }
        .features-area .item {
          padding: 50px 30px;
          background: #ffffff;
          border-radius: 8px;
          position: relative;
          z-index: 1;
          overflow: hidden;
          margin-bottom: 30px;
        }
        .features-area .item > i {
          display: inline-block;
          font-size: 50px;
          margin-bottom: 25px;
          color: #086ad8;
          position: relative;
          z-index: 1;
        }
        h5 {
          color: #0e2b3d;
          font-weight: normal;
          line-height: 1.2;
          font-family: 'Inter', sans-serif;
          letter-spacing: 0;
          margin: 0;
        }

        .site-heading h2 {
          display: inline-block;
          font-weight: 600;
          padding-bottom: 20px;
          margin-bottom: 0;
          position: relative;
          letter-spacing: 1px;
          line-height: 1.4;
          margin-top: 40px;
        }
        .site-heading h2::before {
          background: #086ad8 none repeat scroll 0 0;
          bottom: 0;
          content: "";
          height: 2px;
          left: 50%;
          margin-left: -25px;
          position: absolute;
          width: 40px;
        }

        .features-area .fixed-shape {
          position: absolute;
          right: 0;
          top: 0;
          opacity: 0.5;
        }

        /* Media Queries */
        @media (max-width: 992px) {
          .features-area .item {
            padding: 40px 20px;
            margin-bottom: 25px;
          }
          .features-area .item > i {
            font-size: 45px;
          }
          .features-area .item h5 {
            font-size: 16px;
          }
          .features-area .item p {
            font-size: 14px;
          }
        }

        @media (max-width: 768px) {
          .features-area .item {
            padding: 35px 15px;
            margin-bottom: 20px;
          }
          .features-area .item > i {
            font-size: 40px;
          }
          .features-area .item h5 {
            font-size: 14px;
          }
          .features-area .item p {
            font-size: 13px;
          }
        }

        @media (max-width: 576px) {
          .features-area .item {
            padding: 30px 10px;
            margin-bottom: 15px;
          }
          .features-area .item > i {
            font-size: 35px;
          }
          .features-area .item h5 {
            font-size: 13px;
          }
          .features-area .item p {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default KeyBenefits;
